import styled, { css } from 'styled-components';
import { borderRadiusSm, COLORS } from 'assets/styled';
import { respondTo } from 'assets/styled/breakpoints';

interface StyledProps {
  imageLoaded: boolean;
}

export const Container = styled.div`
  position: relative;
  margin: 0 auto;
  padding: 50rem 0;
  max-width: 1440rem;
  width: 100%;

  ${respondTo.smallLaptop`
    padding: 50rem 15rem;
  `}

  ${respondTo.smallTablet`
    padding: 20rem 15rem;
  `}
`;

export const BackWrapper = styled.div`
  margin-bottom: 20rem;
`;

export const CompanyDetailsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10rem;
  width: 100%;

  ${respondTo.smallTablet`
    gap: 20rem;
  `}
`;

export const ToggleStateWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 10rem;

  ${respondTo.smallTablet`
    justify-content: center;
  `}

  ${respondTo.smallPhone`
    margin-left: 0;
    width: 100%;
    justify-content: center;
  `}
`;

export const ToggleStateLabel = styled.label`
  font-size: 16rem;
  font-weight: 400;
  color: ${COLORS.GREEN};
`;

export const Row = styled.div`
  display: flex;
  gap: 10rem;

  ${respondTo.midTablet`
    flex-direction: column;
  `}
`;

export const RowGap = styled.div`
  display: flex;
  gap: 10rem;
  width: 50%;

  ${respondTo.midTablet`
    width: 100%;
  `}

  ${respondTo.smallTablet`
    justify-content: center;
  `}
`;

export const ContentWrapper = styled.div`
  margin-bottom: 50rem;
  display: flex;
  gap: 50rem;
  align-items: center;

  ${respondTo.smallLaptop`
    gap: 30rem;
  `}

  ${respondTo.smallTablet`
    flex-direction: column;
    justify-content: center;
    align-items: center;
  `}

  ${respondTo.smallTablet`
    margin-bottom: 20rem;
  `}
`;

export const CompanyName = styled.h2`
  font-weight: 300;
  font-size: 50rem;
  color: ${COLORS.BLACK};

  ${respondTo.bigTablet`
    font-size: 40rem;
  `}

  ${respondTo.smallTablet`
    font-size: 30rem;
  `}

  ${respondTo.smallTablet`
    text-align: center;
  `}
`;

export const InfoText = styled.span`
  font-weight: 400;
  font-size: 18rem;
  display: inline-block;
  color: ${COLORS.GREEN};
  white-space: nowrap;

  ${respondTo.smallTablet`
    font-size: 16rem;
  `}
`;

export const InfoValue = styled.span`
  font-weight: 400;
  font-size: 18rem;
  display: inline-block;
  color: ${COLORS.BLACK};

  ${respondTo.smallTablet`
    font-size: 16rem;
  `}
`;

export const imageStyle = css`
  border-radius: ${borderRadiusSm};
  ${(props: StyledProps) =>
    props.imageLoaded
      ? css`
          border-radius: ${borderRadiusSm};
          border: 1px solid ${COLORS.BORDER};
        `
      : css`
          width: 0;
          height: 0;
          opacity: 0;
        `};
`;

export const imageContainerStyle = css`
  width: 100%;
  max-width: 300rem;
  ${respondTo.bigPhone`
    max-width: 100%;
  `};
`;
